<template>
  <div class="table-container">
    <ods-module class="table-content">
      <div v-if="movimientos">
        <ods-table
        :data="listadoMovimientos"
        class="table-style"
        @row-click="openDetalleMovimientos"
        highlight-current-row
        reserve-selection>
        <ods-table-column
        label="ESTADO"
        min-width="100"
        sortable
        class-name="cell-tag">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <ods-tag v-if="scope.row.codestadoqr == '01'" size="medium" type="default">{{ scope.row.desestadoqr }}</ods-tag>
            <ods-tag v-else-if="scope.row.codestadoqr == '02'" size="medium" type="danger">{{ scope.row.desestadoqr }}</ods-tag>
            <ods-tag v-else-if="scope.row.codestadoqr == '03'" size="medium" type="secondary">{{ scope.row.desestadoqr }}</ods-tag>
            <ods-tag v-else-if="scope.row.codestadoqr == '04'" size="medium" type="success">{{ scope.row.desestadoqr }}</ods-tag>
          </div>
        </template>
        </ods-table-column>
        <ods-table-column
        prop="desrechazoqr"
        label="MOTIVO RECHAZO"
        min-width="150"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="idpan"
        label="TARJETA"
        min-width="100"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="destpv"
        label="TERMINAL"
        min-width="120"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="fecha"
        label="FECHA"
        min-width="120"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="importe"
        label="IMPORTE"
        min-width="120"
        sortable>
        </ods-table-column>
        <ods-table-column
        prop="clamoniso"
        label="MONEDA"
        min-width="51"
        sortable>
        </ods-table-column>
      </ods-table>
      <ods-pagination
      layout="prev, pager, next"
      style="text-align: right; padding: 20px;"
      @current-change="handleCurrentChange"
      :page-size="regPorPag"
      :current-page.sync="primero"
      :total=regTotales></ods-pagination>
      </div>
      <div v-else style="text-align: center; margin-top: 30px;">
        <ods-row>
          <img :src="require('@/assets/icons/pic_map.svg')">
        </ods-row>
        <ods-row>
          <span class="todas-las-rutas-de-e">Sin resultados de búsqueda</span>
        </ods-row>
      </div>
    </ods-module>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
  props: {
    movimientos: Boolean,
    numeroComercio: Number,
    numeroCadena: Number,
    regTotales: Number,
    listadoVuelta: Object,
    comercio: String,
    primero: Number
  },
  data () {
    return {
      data: {},
      mostrarMovimiento: true,
      rowSeleccionada: '',
      regPorPag: 5,
      pag: 1,

      icon: 'overflow-menu',
      popoverPosition: 'left-end',
      mobilePopoverPosition: 'bottom-end',
      boundariesElement: '#root',
      myClass: 'myClass',
      actionMenuRow: false,
      cadenaOComercio: '',
      pantalla: ''
    }
  },
  methods: {
    ...mapGetters([
      'getlistMovimientosData',
      'getCodcom',
      'getIndMasDatos',
      'getClaveInicio',
      'getClaveFin',
      'getPantPagina'
    ]),
    openDetalleMovimientos (index, row) {
      if (this.numeroComercio !== 0) {
        this.cadenaOComercio = this.numeroComercio
        this.pantalla = 'com'
        const paramsCadenaComercio = JSON.stringify({
          comercio: this.comercio,
          descomercio: this.descomercio,
          numComercio: this.numComercio
        })
        sessionStorage.setItem('appCadenaComercio', paramsCadenaComercio)
      } else if (this.numeroCadena !== 0) {
        this.cadenaOComercio = this.numeroCadena
        this.pantalla = 'cad'
      }
      this.$router.push({ path: '/detallemovimientos/', query: { pantalla: this.pantalla, reg: this.cadenaOComercio, l: this.listadoVuelta, movimiento: index } })
    },
    handleCurrentChange (val) {
      const storageAppData = JSON.parse(sessionStorage.getItem('appPagina'))
      if (storageAppData.pagina + 1 === val || storageAppData.pagina - 1 === val) {
        if (val > storageAppData.pagina) {
          this.data = {
            dcodcom: this.$store.getters.getCodcom,
            davanzar: 'true',
            dretroceder: 'false',
            dindMasDatos: this.$store.getters.getIndMasDatos,
            dclaveInicio: this.$store.getters.getClaveInicio,
            dclaveFin: this.$store.getters.getClaveFin,
            dpantPagina: this.$store.getters.getPantPagina
          }
        } else if (val < storageAppData.pagina) {
          this.data = {
            dcodcom: this.$store.getters.getCodcom,
            davanzar: 'false',
            dretroceder: 'true',
            dindMasDatos: this.$store.getters.getIndMasDatos,
            dclaveInicio: this.$store.getters.getClaveInicio,
            dclaveFin: this.$store.getters.getClaveFin,
            dpantPagina: this.$store.getters.getPantPagina
          }
        }
      } else {
        var pagAnterior = 0
        pagAnterior = val - 1
        var fin = 0
        var claveInicioAnterior = ''
        var claveFinAnterior = ''
        var avanzar = 'false'
        var retroceder = 'false'
        fin = pagAnterior * this.regPorPag
        if (fin !== 0) {
          avanzar = 'true'
          retroceder = 'false'
          claveFinAnterior = fin + '/' + this.regTotales
          claveInicioAnterior = (fin - (this.regPorPag - 1)) + '/' + this.regTotales
        }
        this.data = {
          dcodcom: this.$store.getters.getCodcom,
          davanzar: avanzar,
          dretroceder: retroceder,
          dindMasDatos: '',
          dclaveInicio: claveInicioAnterior,
          dclaveFin: claveFinAnterior,
          dpantPagina: pagAnterior
        }
      }
      this.listadoVuelta = this.data
      const paramsPagina = JSON.stringify({
        pagina: val
      })
      sessionStorage.setItem('appPagina', paramsPagina)
      this.executeListMovimientos(this.data)
    },
    executeListMovimientos (data) {
      this.$store.dispatch('listMovimientos', data).then(r => {
        this.loadingComercio = false
        if (r.error === true) {
          this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
        } else {
          if (r.vacio === true) {
            this.mostrarMovimientos = false
          } else {
            this.mostrarMovimientos = true
          }
        }
      }).catch(e => {
        console.error('Error in list Movimientos - App', e)
      })
    }
  },
  computed: {
    listadoMovimientos () {
      let datosMovimientos = []
      if (this.$store.getters.getlistMovimientosData !== undefined) {
        if (this.$store.getters.getlistMovimientosData !== '') {
          datosMovimientos = this.$store.getters.getlistMovimientosData
        }
      }
      return datosMovimientos
    }
  }
}
</script>
<style lang="scss" scoped>
.table-container {
  background-color: $--color-white;
}

.table-content {
  padding: rem(10);
}

.table-style {
  width: 100%
}

.todas-las-rutas-de-e {
    height: 24px;
    color: #6E767D;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
}

.myClass{
    width: 144px;
    height: 648px;
    border-radius: 0;
    padding: 0;
  }
</style>
